<template>
  <div></div>
</template>
<script>
export default {
  created () {
    const that = this
    const { params, query } = that.$route
    const { path } = params
    const changeRouter = () => {
      that.$router.replace({ path: '/' + path, query })
    }
    if (window.__POWERED_BY_QIANKUN__) {
      setTimeout(function () {
        changeRouter()
      }, 1)
    } else {
      changeRouter()
    }
  }
}
</script>
